export function buildProspectStateCounts(prospects = []) {
  const counts = {};
  for (const prospect of prospects) {
    const code = String(prospect?.status || '').trim().toUpperCase();
    if (!code) continue;
    counts[code] = (counts[code] || 0) + 1;
  }
  return counts;
}

export function resolveFinalProspectStatusCode(prospectStatuses = []) {
  const active = prospectStatuses.filter((status) => status.is_active !== false);
  const statuses = active.length > 0 ? active : prospectStatuses;
  if (!statuses.length) return 'SALE';

  const saleStatus = statuses.find(
    (status) => String(status.code).trim().toUpperCase() === 'SALE'
  );
  if (saleStatus) return 'SALE';

  const sorted = [...statuses].sort(
    (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0)
      || String(a.code).localeCompare(String(b.code))
  );
  return String(sorted[sorted.length - 1]?.code || '').trim().toUpperCase();
}

function normalizeProspectStateCounts(stateData = {}) {
  const normalized = {};
  Object.entries(stateData || {}).forEach(([code, count]) => {
    const key = String(code).trim().toUpperCase();
    if (!key) return;
    normalized[key] = (normalized[key] || 0) + (count || 0);
  });
  return normalized;
}

export function computeProspectCompletionRate(stateData = {}, prospectStatuses = []) {
  const normalized = normalizeProspectStateCounts(stateData);
  const total = Object.values(normalized).reduce((sum, value) => sum + (value || 0), 0);
  if (total <= 0) return 0;

  const finalCode = resolveFinalProspectStatusCode(prospectStatuses);
  return ((normalized[finalCode] || 0) / total) * 100;
}

export function resolveProspectStateDistribution(apiStates = {}, prospects = []) {
  const fromProspects = buildProspectStateCounts(prospects);
  const prospectTotal = Object.values(fromProspects).reduce((sum, value) => sum + (value || 0), 0);
  if (prospectTotal > 0) {
    return fromProspects;
  }

  const fromApi = apiStates || {};
  const apiTotal = Object.values(fromApi).reduce((sum, value) => sum + (value || 0), 0);
  return apiTotal > 0 ? fromApi : fromProspects;
}
